'use client';

import type { BreadcrumbProps } from '@/core/types';

import React from 'react';

import { Iconify } from '@/components/iconify';
import { Box, Container, Typography } from '@/components/ui';

import { RouterLink } from '@/routes/components';

export default function Breadcrumb({
  items,
  separator = 'lucide:chevron-right',
  maxItems = 8,
  itemsBeforeCollapse = 1,
  itemsAfterCollapse = 1,
  className = '',
}: BreadcrumbProps) {
  const renderSeparator = () => <Iconify icon={separator as any} className="w-4 h-4" />;

  return (
    <div className={`bg-white ${className} `}>
      <Container>
        <Box
          component="nav"
          className="flex flex-wrap items-center text-sm border-b border-black/20 mb-[48px] md:mb-[80px] py-4 md:py-6"
          aria-label="breadcrumb"
        >
          {items.map((item, index) => {
            const isLast = index === items.length - 1;

            return (
              <React.Fragment key={index}>
                {item.link && !isLast ? (
                  <RouterLink
                    href={item.link}
                    className="text-[14px] md:text-[16px] text-[var(--color-blackish-gray)] hover:text-primary-main"
                  >
                    {item.title}
                  </RouterLink>
                ) : (
                  <Typography
                    className={`${isLast ? 'text-[14px] md:text-[16px] font-medium text-primary-main' : 'text-gray-600'}`}
                  >
                    {item.title}
                  </Typography>
                )}

                {!isLast && (
                  <Box className="mx-2 [&>svg]:text-black [&>svg]:w-[22px] [&>svg]:h-[22px]">
                    {renderSeparator()}
                  </Box>
                )}
              </React.Fragment>
            );
          })}
        </Box>
      </Container>
    </div>
  );
}
